import React, { Component } from 'react';

// WarehouseVisibility embeds the FC Outbound portal (warehouse-analytics-service) inside Bradman's
// content pane via an iframe. The portal is hosted on its own domain and authenticates the Bradman
// user itself (standalone auth: it validates the token against authenticationservice), so the iframe
// src carries the logged-in access token as ?authToken=<token>&origin=BRADMAN. The token comes from
// the same place the rest of Bradman reads it: localStorage['user'].accessToken.
// It also carries the currently-selected FC as &facility=<facilityId> (from
// localStorage['selectedFacility'], the same source the rest of Bradman uses) so the portal shows
// data for the FC the user picked in the top bar, not its server-side default. The portal keeps the
// facility param across its auth redirect (only authToken/origin are stripped), so every section
// renders against the selected FC.
const PORTAL_BASE = 'https://warehouse-analytics.jumbotail.com/outbound';

class WarehouseVisibility extends Component {
    portalUrl() {
        const params = [];
        try {
            const user = JSON.parse(localStorage.getItem('user'));
            const token = user && user.accessToken;
            if (token) {
                params.push('authToken=' + encodeURIComponent(token));
                params.push('origin=BRADMAN');
            }
        } catch (e) {
            /* no/invalid stored user — load bare; the portal will show its unauthorized page */
        }
        try {
            const fc = JSON.parse(localStorage.getItem('selectedFacility'));
            if (fc && fc.facilityId) {
                params.push('facility=' + encodeURIComponent(fc.facilityId));
            }
        } catch (e) {
            /* no/invalid selected facility — portal falls back to its default FC */
        }
        return params.length ? PORTAL_BASE + '?' + params.join('&') : PORTAL_BASE;
    }

    render() {
        return (
            <iframe
                title="Warehouse Visibility"
                src={this.portalUrl()}
                // Fill the content pane; the header bar is ~52px, so subtract it from the viewport.
                style={{
                    width: '100%',
                    height: 'calc(100vh - 52px)',
                    border: 'none',
                    display: 'block',
                }}
            />
        );
    }
}

export default WarehouseVisibility;



// WEBPACK FOOTER //
// ./src/screens/WarehouseVisibility/Components/WarehouseVisibility.js